import { useEffect } from "react";

const SITE_URL = "https://toofanloan.com";

interface SeoProps {
  title: string;
  description: string;
  path: string;
}

const Seo = ({ title, description, path }: SeoProps) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    meta.setAttribute("content", description);
    document.head.appendChild(meta);

    const canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    canonical.setAttribute("href", `${SITE_URL}${path}`);
    document.head.appendChild(canonical);

    return () => {
      document.title = previousTitle;
      meta.remove();
      canonical.remove();
    };
  }, [title, description, path]);

  return null;
};

export default Seo;
